import React from 'react';
import { Sun, Moon, ZoomIn, ZoomOut } from 'lucide-react';
import { useTheme } from '../theme/ThemeProvider';

const MIN_FONT_SIZE_PERCENT = 80;
const MAX_FONT_SIZE_PERCENT = 150;
const FONT_SIZE_STEP_PERCENT = 10;

const adjustFontSize = (increase: boolean) => {
  const root = document.documentElement;
  const current = parseFloat(root.style.fontSize) || 100;
  const next = current + (increase ? FONT_SIZE_STEP_PERCENT : -FONT_SIZE_STEP_PERCENT);
  const clamped = Math.min(MAX_FONT_SIZE_PERCENT, Math.max(MIN_FONT_SIZE_PERCENT, next));
  root.style.fontSize = `${clamped}%`;
};

export const AccessibilityMenu: React.FC = () => {
  const { isDarkMode, toggleDarkMode, highContrast, toggleHighContrast } = useTheme();

  return (
    <div
      className="fixed bottom-4 right-4 bg-white dark:bg-gray-800 rounded-lg shadow-xl p-4 space-y-2"
      role="region"
      aria-label="Accessibility controls"
    >
      <button
        onClick={toggleDarkMode}
        className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
        aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDarkMode ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
      </button>

      <button
        onClick={toggleHighContrast}
        className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
        aria-label={highContrast ? 'Disable high contrast' : 'Enable high contrast'}
      >
        <span className={`text-sm font-bold ${highContrast ? 'text-yellow-500' : ''}`}>Aa</span>
      </button>

      <button
        onClick={() => adjustFontSize(true)}
        className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
        aria-label="Increase font size"
      >
        <ZoomIn className="h-5 w-5" />
      </button>

      <button
        onClick={() => adjustFontSize(false)}
        className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
        aria-label="Decrease font size"
      >
        <ZoomOut className="h-5 w-5" />
      </button>
    </div>
  );
};
